import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Get API base URL from environment variables
const API_BASE_URL = process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL;

// Async thunk for fetching recruiter stats
export const fetchRecruiterStats = createAsyncThunk(
  "resumeStats/fetchRecruiterStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/super-admin/recruiter-stats`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch recruiter stats");
      }

      const result = await response.json();

      if (result.success) {
        const { data } = result;

        // Transform API data to match card structure
        const transformedData = [
          {
            title: "Total Recruiters",
            subtitle: "",
            value: data.totalRecruiters.toString(),
            growth: "",
            growthText: "",
            valueColor: "#8b5cf6",
          },
          {
            title: "Recruiters with Companies",
            subtitle: "",
            value: data.registeredRecruiters.toString(),
            growth: "",
            valueColor: "#8b5cf6",
          },
          {
            title: "Recruiters without Companies ",
            subtitle: "",
            value: data.notRegisteredRecruiters.toString(),
            growth: "",
            valueColor: "#8b5cf6",
          },
        ];

        return transformedData;
      } else {
        throw new Error(result.message || "Failed to fetch recruiter stats");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const resumeStatsSlice = createSlice({
  name: "resumeStats",
  initialState: {
    statsData: [
      {
        title: "Total Recruiters",
        subtitle: "Updated Wed, January",
        value: "0",
        growth: "+23%",
        growthText: "compared to last month",
        valueColor: "#8b5cf6",
      },
      {
        title: "Registered Recruiters",
        subtitle: "Updated Wed, January",
        value: "0",
        growth: "",
        growthText: "recruiters are not registered",
        lastUpdate: "Last month",
        lastUpdateValue: "0",
        valueColor: "#8b5cf6",
      },
      {
        title: "Not Registered Recruiters",
        subtitle: "Updated Wed, January",
        value: "0",
        growth: "+5%",
        growthText: "recruiters without company association",
        valueColor: "#8b5cf6",
      },
    ],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetResumeStats: (state) => {
      state.statsData = [
        {
          title: "Total Recruiters",
          subtitle: "Updated Wed, January",
          value: "0",
          growth: "+23%",
          growthText: "compared to last month",
          valueColor: "#8b5cf6",
        },
        {
          title: "Registered Recruiters",
          subtitle: "Updated Wed, January",
          value: "0",
          growth: "",
          growthText: "recruiters are not registered",
          lastUpdate: "Last month",
          lastUpdateValue: "0",
          valueColor: "#8b5cf6",
        },
        {
          title: "Not Registered Recruiters",
          subtitle: "Updated Wed, January",
          value: "0",
          growth: "+5%",
          growthText: "recruiters without company association",
          valueColor: "#8b5cf6",
        },
      ];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecruiterStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecruiterStats.fulfilled, (state, action) => {
        state.loading = false;
        state.statsData = action.payload;
        state.error = null;
      })
      .addCase(fetchRecruiterStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, resetResumeStats } = resumeStatsSlice.actions;

export default resumeStatsSlice.reducer;
